














import { Component, Prop, Vue } from 'vue-property-decorator'
import NavItem from '@/models/NavItem'
import { NavItemTypes } from '@/models/Types'

@Component
export default class Footer extends Vue {
  @Prop({ default: [] }) private navList?: NavItem[]

  // data
  copyrightBy: string = 'Cabin Artists'
  currentYear: number = new Date().getFullYear()

  // computed
  get emailAddress(): NavItem|undefined {
    return this.navList!.find(item => item.type === NavItemTypes.EMAIL)
  }

  get navItems(): NavItem[] {
    return this.navList!.filter(item => item.type === NavItemTypes.FOOTER)
  }
}
